
ADILF.define('adilf/util/ads',['require','exports','module','streamhub-sdk/jquery','adilf/debug','adilf/context'],function (require, exports, module) {/* Util: ADI Ads & Omnijax Helper
Things it needs to do:
    - Count number of 'more' clicks and increment via omnijax.page()
    - Refresh visible ads
    - Change page when context uri changes
*/
"use strict";

var jquery = require('streamhub-sdk/jquery');
var Debug = require('adilf/debug');
var Context = require('adilf/context');

var AdsHelper = function(conf) {
    /* istanbul ignore if */
    if(!conf) { conf = {}; }
    var self = this;
    self.name = conf.name || window.document.title;
    self.title = conf.title || window.document.title;
    self.uri = conf.uri || Context.getPage().permalink;
    self.pageMoreCount = 0;
    self.pageMoreUriSuffix = conf.pageMoreUriSuffix || 'comments';
    self.debug = new Debug("AdsHelper ("+self.name+")");
};

AdsHelper.prototype.setActive = function() {
    var self = this;
    if(self.uri == Context.getPage().permalink) {
        self.debug.print("Not changing context -- current view already active");
        return;
    }
    window.document.title = self.title;
    Context.reset({'uri':self.uri});
    /* istanbul ignore else */
    if ( window.history && window.history.pushState ) {
        window.history.replaceState( {}, window.document.title, self.uri );
    }
    self.pagePing();
};

AdsHelper.prototype.pageMore = function() {
    var self = this;
    self.pageMoreCount++;
    var pageMoreUri = self.uri + "/" + self.pageMoreUriSuffix + "-" + self.pageMoreCount + ".html";
    self.debug.print("Executing omnijax.page event with uri:", pageMoreUri);
    window.omnijax.page(pageMoreUri);
};

// TODO: I don't know
AdsHelper.prototype.pageChange = function(opts) {
    if(!(opts && opts.uri)) {
        return;
    }
    var self = this;
    Context.reset({'uri':opts.uri});
    self.uri = Context.getPage().permalink;
    if(opts.title) { self.title = opts.title; }
    window.document.title = self.title;
    self.pagePing();
};

AdsHelper.prototype.pagePing = function() {
    var self = this;
    self.debug.print("Executing omnijax.page event with uri:", self.uri);
    window.omnijax.page(self.uri);
};

AdsHelper.prototype.refreshViewableUnits = function() {
    var self = this;
    self.debug.print("Refreshing viewable ad units");
    window.AdManager.refreshViewableUnits();
};

AdsHelper.prototype.refreshUnits = function(units) {
    var self = this;
    self.debug.print("Refreshing ad units:", units);
    window.AdManager.refreshUnits(units);
};

module.exports = AdsHelper;
});
